<template>
  <div>
    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">新增C端用户线索</span>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <div class="add-container">
            <div class="add-user-header">
              <div class="header-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="header-text">
                <h3>批量上传</h3>
                <p>批量上传excel名单</p>
              </div>
            </div>
            <div class="batch-steps">
              <el-steps :active="batchStep" align-center>
                <el-step title="下载模板"></el-step>
                <el-step title="上传文件"></el-step>
                <el-step title="确认导入"></el-step>
              </el-steps>
            </div>

            <div class="batch-content">
              <!-- 步骤1：下载模板 -->
              <div v-if="batchStep === 0" class="step-content">
                <div class="step-icon">
                  <i class="el-icon-download"></i>
                </div>
                <h5>选择导入方式</h5>
                <p>您可以先下载模板按格式填写，或者直接上传已准备好的Excel文件</p>
                <div class="template-actions">
                  <el-button type="primary" size="small" @click="downloadTemplate" icon="el-icon-download">
                    下载模板
                  </el-button>
                  <el-button type="success" size="small" @click="skipToUpload" icon="el-icon-upload2">
                    直接上传
                  </el-button>
                </div>
              </div>

              <!-- 步骤2：上传文件 -->
              <div v-if="batchStep === 1" class="step-content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action="''"
                  ref="importWordExcelRef"
                  :auto-upload="false"
                  :file-list="uploadFileList"
                  :before-upload="beforeUpload"
                  :on-change="handleFileChange"
                  :on-remove="handleFileRemove"
                  accept=".xlsx,.xls"
                  :limit="1"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件。</div>
                  <div class="el-upload__tip" slot="tip" style="color: red;">
                    excel导入的信息,如果已经注册过,会覆盖原有信息,系统学校名称字段要与B端已有的学校名称一致
                  </div>

                  <!-- 自定义文件列表模板 -->
                  <div slot="file" slot-scope="{file}">
                    <div class="custom-file-item">
                      <div class="file-info">
                        <i class="el-icon-document file-icon"></i>
                        <span class="file-name">{{ file.name }}</span>
                      </div>
                      <div class="file-actions">
                        <!-- 显示绿色完成图标 -->
                        <i class="el-icon-circle-check success-icon" v-if="file.status === 'ready'"></i>
                        <!-- 移除按钮 -->
                        <i class="el-icon-close remove-icon" @click="handleFileRemove(file, uploadFileList)"></i>
                      </div>
                    </div>
                  </div>
                </el-upload>
              </div>

              <!-- 步骤3：确认导入 -->
              <div v-if="batchStep === 2" class="step-content">
                <p v-if="uploadedFileName">已选择文件：<span class="highlight">{{ uploadedFileName }}</span></p>
                <div style="margin: 20px 0;">
                  <el-select
                    placeholder="请选择赛区（必选）"
                    style="width: 100%;"
                    v-model="importWordExcel.districtId"
                    clearable
                  >
                    <el-option
                      v-for="item in dict_district"
                      :key="item.id"
                      :label="item.districtName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>

                <el-button size="small" type="success" @click="confirmUpload" icon="el-icon-check">
                  确认导入
                </el-button>
              </div>

            </div>

            <div class="batch-actions">
              <el-button size="small" v-if="batchStep > 0" @click="prevStep">上一步</el-button>
              <el-button size="small" v-if="batchStep === 1 && uploadedFileName" type="primary" @click="nextStep">下一步</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="add-container">
            <div class="single-add-container">
              <div class="add-user-header">
                <div class="header-icon">
                  <i class="el-icon-user"></i>
                </div>
                <div class="header-text">
                  <h3>添加用户信息</h3>
                  <p>请填写用户的基本信息，可添加多个用户</p>
                </div>
              </div>

              <el-form
                :model="addInfoForm"
                label-width="66px"
                ref="addInfoFormRef"
                :rules="addInfoRules"
                class="user-form"
              >
                <div class="user-list">
                  <div
                    v-for="(item, index) in addInfoForm.addUserList"
                    :key="index"
                    class="user-item"
                  >
                    <div class="user-item-header">
                      <span class="user-number">用户 {{ index + 1 }}</span>
                      <div class="action-buttons">
                        <el-button
                          v-if="(index + 1) === addInfoForm.addUserList.length"
                          type="primary"
                          size="mini"
                          icon="el-icon-plus"
                          circle
                          @click="addClicked"
                          title="添加用户"
                        ></el-button>
                        <el-button
                          v-if="addInfoForm.addUserList.length > 1"
                          type="danger"
                          size="mini"
                          icon="el-icon-minus"
                          circle
                          @click="subtractClicked(index)"
                          title="删除用户"
                        ></el-button>
                      </div>
                    </div>

                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item
                          label="手机号"
                          :prop="`addUserList.${index}.phone`"
                          :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }]"
                        >
                          <el-input
                            v-model="item.phone"
                            placeholder="请输入手机号"
                            prefix-icon="el-icon-phone"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="姓名"
                          :prop="`addUserList.${index}.userName`"
                          :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
                        >
                          <el-input
                            v-model="item.userName"
                            placeholder="请输入姓名"
                            prefix-icon="el-icon-user"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
            </div>
            <div style="text-align: center;">
              <el-button size="small" type="primary" style="width: 120px;" @click="addUserInfoClicked">保 存</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">C端用户数据池</span>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-top: 34px">
        <el-col :span="6" v-for="(item, i) of dataManagementList" v-bind:key="i">
          <gameToolBackView :itemData="item" :key="i" @itemClicked="racingToolClicked"></gameToolBackView>
        </el-col>
      </el-row>
    </el-card>

  </div>
</template>

<script>
import { saveSysUserBatch } from '@/http/api'

export default {
  name: 'marketingOperationsHome',
  data () {
    return {
      dataManagementList: [
        // {
        //   icon: 'icon-xuexiao_xuexiaoxinxi',
        //   rightTitle: '学校/机构管理',
        //   rightDesc: '可新增、修改、审核学校/机构信息',
        //   path: '/system_data_Management/system_school_management',
        //   menuTag: '2',
        //   flag: this.$chnEngStatusCode.b_school_management
        // },
        {
          icon: 'icon-user',
          rightTitle: '选手管理',
          rightDesc: '可新增管理选手',
          path: '/c_data_Management/c_player_registInfo',
          menuTag: '1',
          flag: this.$chnEngStatusCode.c_player_registInfo
        },
        {
          icon: 'icon-renzhengyonghu',
          rightTitle: '教师子女管理',
          rightDesc: '可修改教师子女信息',
          path: '/c_data_Management/c_player_teacherinfo_child',
          menuTag: '3',
          flag: this.$chnEngStatusCode.c_player_teacherinfo
        }
      ],
      addInfoForm: {
        addUserList: [
          {
            phone: '',
            userName: ''
          }
        ]
      },
      batchStep: 0, // 批量新增步骤
      uploadedDataCount: 0, // 上传的数据条数
      uploadedFileName: '', // 上传的文件名
      selectedFile: null, // 选择的文件对象
      uploadFileList: [], // 上传组件的文件列表
      addInfoRules: {
        'addUserList.phone': [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      importWordExcel: {
        uploadUrl: this.$env.baseIP + 'erpUser/importSysUserBatch',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        },
        districtId: null
      },

      matchList: [
        {
          img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png',
          title: 'SPBCN×个人赛'
        }
        // {
        //   img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon7.png',
        //   title: 'ITSO×团体赛'
        // },
        // {
        //   img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon4.png',
        //   title: 'CEBSB×汉英双拼'
        // },
        // {
        //   img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon8.png',
        //   title: 'NASCC×北美冠军挑战赛'
        // },
        // {
        //   img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon9.png',
        //   title: 'ASBC×亚洲杯'
        // },
        // {
        //   img: 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon10.png',
        //   title: 'WSA×拼词世界杯'
        // }
      ]

    }
  },
  created () {
  },
  methods: {
    nextPage () {
      this.$router.push('/marketing_operations/c_data_detail')
    },
    tapFn (index) {
      this.index = index
    },
    racingToolClicked (itemData) {
      if (itemData.path) {
        this.$router.push(itemData.path)
      }
    },
    distChange (e) {
      this.editInfoForm.districtName = this.dict_district.find(item => item.id === e).districtName
    },
    // 下载模板
    downloadTemplate () {
      // 这里添加下载模板的逻辑
      var downLoadUrl = this.$env.baseIP + 'erpUser/downloadExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', {})
      this.$message.success('模板下载成功')
      this.batchStep = 1 // 自动进入下一步
    },
    // 跳过下载直接上传
    skipToUpload () {
      this.batchStep = 1 // 直接进入上传步骤
    },
    // 上传前验证
    beforeUpload (file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                     file.type === 'application/vnd.ms-excel'

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return false
      }

      return true
    },
    // 文件选择变化处理
    handleFileChange (file, fileList) {
      if (file.status === 'ready') {
        this.selectedFile = file.raw
        this.uploadedFileName = file.name
        this.uploadFileList = fileList // 保存文件列表状态
        this.$message.success('文件选择成功，请进入下一步进行确认导入')
      }
    },
    // 文件移除处理
    handleFileRemove (file, fileList) {
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = fileList
    },
    // 上传成功
    uploadSuccess (response, file) {
      console.log('上传成功响应:', response)
      if (response && response.code === 200) {
        this.$message.success('文件上传并导入成功')
        // 直接关闭弹窗并刷新数据
        this.closeBatchDialog()
        this.getDataList('search')
      } else {
        this.$message.error(response.msg || '文件导入失败')
      }
    },
    // 上传失败
    uploadError (error) {
      console.log('上传失败:', error)
      this.$message.error('文件上传失败，请重试')
    },
    // 确认上传
    confirmUpload () {
      // 验证赛区是否选择
      if (!this.importWordExcel.districtId) {
        this.$message.warning('请选择赛区')
        return
      }

      // 验证文件是否选择
      if (!this.selectedFile) {
        this.$message.warning('请先选择要上传的文件')
        return
      }

      // 创建FormData对象进行文件上传
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('districtId', this.importWordExcel.districtId)

      // 使用axios进行文件上传
      this.$http.post(this.importWordExcel.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...this.importWordExcel.headerObj
        }
      }).then(response => {
        console.log('上传成功响应:', response)
        if (response && response.code === 200) {
          this.$message.success('文件上传并导入成功')
          this.closeBatchDialog()
          this.getDataList('search')
        } else {
          this.$message.error(response.msg || '文件导入失败')
        }
      }).catch(error => {
        console.log('上传失败:', error)
        this.$message.error('文件上传失败，请重试')
      })
    },

    // 上一步
    prevStep () {
      if (this.batchStep > 0) {
        this.batchStep--
      }
    },
    // 下一步
    nextStep () {
      if (this.batchStep < 2) {
        this.batchStep++
      }
    },
    // 添加选手信息
    addClicked () {
      this.addInfoForm.addUserList.push({
        phone: '',
        userName: ''
      })
    },
    // 减少选手信息
    subtractClicked (e) {
      console.log('e', e)
      this.addInfoForm.addUserList.splice(e, 1)
    },
    // 新增用户请求
    addUserInfoClicked () {
      console.log('this.addInfoForm', this.addInfoForm)
      saveSysUserBatch(this.addInfoForm.addUserList).then((res) => {
        this.addUserDialogVisible = false
        this.$message.success('添加成功')
        this.getDataList('search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  }
}
</script>

<style lang="less" scoped>

.match-item{
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  .img{
    perspective: 800px;
    text-align: center;
    padding: 10px;
    background-color: #021f5f;
    border-radius: 10px 10px 0 0;
    .flipper{
      position: relative;
      width: 100%;
      height: 100px;
      transform-style: preserve-3d;
      transition: transform 0.5s;
      img{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 68px;
        height: 68px;
        object-fit: contain;
        border-radius: 68px;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        transform: translate(-50%, -50%);
      }
      .back{
        transform: translate(-50%, -50%) rotateY(180deg);
      }
    }
    &:hover .flipper{
      transform: rotateY(180deg);
    }
  }
  .title{
    color: #000;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 20px 0;
  }
}
.match-item1 .img{
  background-color: #fda61b;
}
.match-item2 .img{
  background-color: #811d21;
}
.match-item3 .img{
  background-color: #fec71f;
}
.match-item4 .img{
  background-color: #23913A;
}
.match-item5 .img{
  background-color: #0a4584;
}

.tit{
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}
.add-container{
  border: 1px dashed #b3d8ff;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: #ecf5ff;
  padding: 14px 0;
  width: 100%;
  p{
    text-align: center;
    font-size: 12px;
    color: #909399;
  }
  h5{
    text-align: center;
    margin: 4px 0;
  }
  .step-icon{
    font-size: 18px;
    text-align: center;
  }
}
.template-actions{
  text-align: center;
}
.batch-actions{
  text-align: center;
  margin-top: 10px;
}
::v-deep .el-upload-dragger{
  height: 120px;
  .el-icon-upload{
    font-size: 30px;
    margin: 10px;
  }
}
.upload-demo{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.step-content {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}
/* 单项新增弹窗样式 */
.single-add-container {
  // padding: 20px 0;
}

.add-user-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-left: 20px;
  // padding: 20px;
  // background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  // border-radius: 10px;
}

.header-icon {
  font-size: 30px;
  color: #409eff;
  margin-right: 10px;
}

.header-text h3 {
  margin: 0 0 5px 0;
  color: #000;
  font-size: 14px;
}

.header-text p {
  margin: 0;
  color: #909399;
  font-size: 12px;
}

.user-form {
  max-height: 400px;
  overflow-y: auto;
}

.user-list {
  padding: 10px 0;
}

.user-item {
  margin-bottom: 25px;
  padding: 10px 14px;
  margin-left: 10px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s ease;
}

.user-item:hover {
  border-color: #409eff;
  background: #f8f9fa;
}

.user-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e6e6e6;
}

.user-number {
  font-weight: bold;
  color: #409eff;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

</style>
